/*============================================================================
  OSC General JS Settings
==============================================================================*/

/**
 * Type of console print message enabled
 * @type {string[]}
 */
window.DEBUG_TYPE_LOG ="log";
window.DEBUG_TYPE_WARN = "warn";
window.DEBUG_TYPE_ERROR = "error";
window.cosConsole_DebugType = [window.DEBUG_TYPE_LOG, window.DEBUG_TYPE_WARN, window.DEBUG_TYPE_ERROR];
/* --/// BEGIN OTHER FILE //-- */
	/**
	 * Gestione delle voci del main Menu desktop che possono essere
	 * * Menu Search
	 * * Menu semplice
	 * * Menu con sottomenu
	 */
	function mainMenuItem() {
		let $self = this;
		
		let $itm;
		let $id;
		
		let $sumenuContent = null;
		
		/**
		 * Funzioni di Call Back
		 * @type {null}
		 */
		let callBack = null;
		
		/**
		 * Avvia la chiusura del menu Search
		 */
		this.closeSearchMenu = function () {
			$itm.find('a').data('opened', false);
			if (callBack != null) {
				callBack(this.getId(), false);
			}
		};
		
		/**
		 * Apertura del menu Search
		 */
		this.openSearchMenu = function () {
			$itm.find('a').data('opened', true);
			if (callBack != null) {
				callBack(this.getId(), true);
			}
		};
		
		
		this.isOpened = function () {
			return ($itm.find('a').data('opened') === true);
		};
		
		/**
		 * Init Search MENU
		 * @private
		 */
		this.__initSearchMenu = function () {
			$itm.find('a').on('click', function (e) {
				if (callBack != null) {
					e.preventDefault();
					if ($(this).data('opened') === true) {
						$(this).data('opened', false);
						if (callBack != null) {
							callBack($self.getId(), false, true);
						}
					} else {
						$(this).data('opened', true);
						if (callBack != null) {
							callBack($self.getId(), true, true);
						}
					}
				}
			});
			
			$('#close-search-lnk').on('click',function(e) {
				e.preventDefault();
				$itm.find('a').click();
			})
			
		};
		
		/**
		 * Init simple MENU
		 * @private
		 */
		this._initMenu = function () {
			$itm.hover(function () {
					if (callBack != null) {
						callBack($self.getId(), true);
					}
				},
				function () {
					if (callBack != null) {
						callBack($self.getId(), false);
					}
				});
		};
		
		/**
		 * Init Menu with submenu
		 *
		 * * Si APRE on Mouse hover
		 * * Si CHIUDE on  mouse out
		 * @private
		 */
		this._initSubMenu = function () {
			$sumenuContent = $itm.find('ul');
			let $height = $sumenuContent.offset().top - $(window).scrollTop() + $sumenuContent.outerHeight();
			$itm.hover(function () {
					if (callBack != null) {
						callBack($self.getId(), true, $height);
					}
				},
				function () {
					if (callBack != null) {
						callBack($self.getId(), false, $height);
					}
				});
		};
		
		this.getId = function () {
			return $id;
		};
		
		/**
		 * Imposta il tipo
		 * @param $_itm
		 * @param $_id
		 * @param $_callBack
		 */
		this.init = function ($_itm, $_id, $_callBack) {
			callBack = $_callBack;
			$itm = $_itm;
			$id = $_id;
			switch ($itm.data('meganav-type')) {
				case 'parent':
					this._initSubMenu();
					break;
				case 'child':
					this._initMenu();
					break;
				case "search":
					this.__initSearchMenu();
					break;
				default:
					break;
			}
		};
	}
	
	
	/**
	 * Gestione delle voci del main Menu Mobile
	 * * Menu con sottomenu
	 * * Tasto back
	 */
	function mainMenuItemMobile() {
		let $self = this;
		
		let $itm;
		let $id;
		
		/**
		 * Funzioni di Call Back
		 * @type {null}
		 */
		let callBack = null;
		
		
		/**
		 * Init Search MENU
		 * @private
		 */
		this.__initMenu = function () {
			$itm.find('a').on('click', function (e) {
				if (callBack != null) {
						e.preventDefault();
						callBack($self.getId());
				}
			});
		};
		
		/**
		 * Init Search MENU
		 * @private
		 */
		this.__initBack = function () {
			$itm.find('a').on('click', function (e) {
				if (callBack != null) {
					e.preventDefault();
					callBack($self.getId());
				}
			});
		};
		
		this.getId = function () {
			return $id;
		};
		
		/**
		 * Imposta il tipo
		 * @param $_itm
		 * @param $_callBack
		 */
		this.init = function ($_itm, $_id, $_callBack) {
			callBack = $_callBack;
			$itm = $_itm;
			$id = $_id;
			switch ($itm.data('meganav-type')) {
				case 'parent':
					this.__initMenu();
					break;
				case 'back':
					this.__initBack();
					break;
				default:
					break;
			}
		};
	}
	
	/**
	 * Manage Main Menu event
	 * @constructor
	 */
	function MainMenuController() {
		// Self
		let $self = this;
		let $siteHeader = null;
		let $siteHeaderOriginal_Height = 0;
		
		let $menuSearchContainer = null;
		let $siteHeaderBgScroll = null;
		
		let mainMenuContainer = null;
		
		let burgerMainMenu = null;
		let MenuDrawer = null;
		
		let menuItem = [];
		let menuItemMobile = [];
		let mobileMenuContainerActive = null;
		
		let $headerTransparent;
		
		let opened = false;
		let openedSearch = false;
		
		this.isOpened = function () {
			return opened;
		};
		
		this.isOpenedSearch = function () {
			return openedSearch;
		};
		this.isHeaderTransparent = function () {
			return $headerTransparent;
		};
		
		this.setData = function ($itm, $key, $value ) {
			$itm.attr('data-'+$key,$value);
		};
		
		/**
		 * Gestione BackGround del menu Bianco o del colore impostato dalla sezione specifica
		 * @param $_show
		 */
		this.toggleBgMenu = function ($_show) {
			$("body").trigger("cos-toggleBgMenu-before",$_show);
			opened = $_show;
			if ($headerTransparent) {
				$('.header-wrapper').toggleClass('header-wrapper--transparent', !$_show);
				if ($_show) {
					$('#headerLogoImg').css('display', 'none');
					$('#headerLogoImgBlack').css('display', 'block');
					$('#site-header-bg-menu-onhover').css('opacity',  1);

				} else {
					$('#site-header-bg-menu-onhover').css('opacity', 0);
					if ($(window).scrollTop() > 0) {
						$('#headerLogoImg').css('display', 'none');
						$('#headerLogoImgBlack').css('display', 'block');
						
					} else {
						$('#headerLogoImg').css('display', 'block');
						$('#headerLogoImgBlack').css('display', 'none');
					}
				}
			}
			$("body").trigger("cos-toggleBgMenu-after");
		};
		
		/**
		 * Gestione del container del Menu Search
		 * @param $_show
		 */
		this.toggleSearchMenu = function ($_id, $_show, $_closeFromLink) {
			$("body").trigger("cos-toggleSearchMenu-before", [$_id,$_show, $_closeFromLink]);
			openedSearch = $_show;
			if ($_show) {
				/**
				 * Chiudere mobile menu se è aperto
				 */
				if ($self.menuMobileIsOpened()) {
					$self.toggleMenuMobile();
				}
				$self.setData($siteHeader,'submenu-opened',$_id);
				$self.setData($siteHeaderBgScroll,'submenu-opened',$_id);
				$self.toggleBgMenu($_show);
				$("body").trigger("cos-toggleSearchMenu-show-before", $_id);
				$menuSearchContainer.css('display', 'block');
				
				if (resolution_IsMobile()) {
					$siteHeader.css('height', $(window).outerHeight()+50);
				} else {
					$siteHeader.css('height', $menuSearchContainer.offset().top - $(window).scrollTop() + $menuSearchContainer.outerHeight());
				}
				$('.onlyText','#menu_search').html(theme.headerString.search_close);
				
				$("body").trigger("cos-toggleSearchMenu-show-after", $_id);
				
			} else {
				$("body").trigger("cos-toggleSearchMenu-hide-before", $_id);
				
				$self.setData($siteHeader,'submenu-opened','');
				$self.setData($siteHeaderBgScroll,'submenu-opened','');
				
				if ($_closeFromLink) {
					$self.toggleBgMenu($_show);
				}
				$menuSearchContainer.css('display', 'none');
				$siteHeader.css('height', $siteHeaderOriginal_Height);
				
				$('.onlyText','#menu_search').html(theme.headerString.search);
				
				
				$("body").trigger("cos-toggleSearchMenu-hide-after", $_id);
			}
			$("body").trigger("cos-toggleSearchMenu-after", $_id);
		};
		
		/**
		 * Chiamato dall'ITEM mainMenuItem
		 * @param $_show
		 */
		this.toggleMenu = function ($_id, $_show) {
			console.log('TOggle Nenu');
			$("body").trigger("cos-toggleMenu-before", $_id,$_show);
			
			if ($_show) {
				$self.setData($siteHeader,'submenu-opened',$_id);
				$self.setData($siteHeaderBgScroll,'submenu-opened',$_id);
			} else {
				$self.setData($siteHeader,'submenu-opened','');
				$self.setData($siteHeaderBgScroll,'submenu-opened','');
			}
			
			menuItem[$('#menu_search').data('meganav-id')].closeSearchMenu();
			$siteHeader.css('height', $siteHeaderOriginal_Height);
			$("body").trigger("cos-toggleMenu-after", $_id,$_show);
		};
		
		/**
		 * Chiamato dall'ITEM mainMenuItem
		 * @param $_height
		 */
		this.toggleSubMenu = function ($_id, $_show, $_height) {
			$("body").trigger("cos-toggleSubMenu-before", $_id);
			if ($_show) {
				
				$("body").trigger("cos-toggleSubMenu-show-before", $_id);
				menuItem[$('#menu_search').data('meganav-id')].closeSearchMenu();
				
				$self.setData($siteHeader,'submenu-opened',$_id);
				$self.setData($siteHeaderBgScroll,'submenu-opened',$_id);
				
				
				$siteHeader.css('height', $_height);
				$("body").trigger("cos-toggleSubMenu-show-after", $_id);
			} else {
				$("body").trigger("cos-toggleSubMenu-hide-before", $_id);
				
				$self.setData($siteHeader,'submenu-opened','');
				$self.setData($siteHeaderBgScroll,'submenu-opened','');
				$siteHeader.css('height', $siteHeaderOriginal_Height);
				$("body").trigger("cos-toggleSubMenu-hide-after", $_id);
			}
			$("body").trigger("cos-toggleSubMenu-after", $_id);
		};
		
		
		this.createMainMenuItem = function ($_itm, $_callBack) {
			let id = $_itm.data('meganav-id');
			menuItem[id] = new mainMenuItem();
			menuItem[id].init($_itm, id, $_callBack);
		};
		
		this.createMainMenuItemMobile = function ($_itm, $_callBack) {
			let id = $_itm.data('meganav-id');
			menuItemMobile[id] = new mainMenuItemMobile();
			menuItemMobile[id].init($_itm, id, $_callBack);
		};
		
		this.handleEvent = function () {
			/**
			 * Visualizza il background all'hover sull'oggetto contenitore del Main Menu
			 */
			if (resolution_IsDesktop() || resolution_IsLarge()) {
				mainMenuContainer.hover(function () {
						$self.toggleBgMenu(true);
					},
					function () {
						if (!$self.isOpenedSearch()) {
							$self.toggleBgMenu(false);
						}
					});
			}

			/*$('body').on('cos-toggleSearchMenu-before', function(e,$_id, $_show, $_closeFromLink) {
			
				
				
			} );
			*/
		};
		
		/**
		 * Crea la singola voce di menu
		 */
		this.createMainMenuItems = function () {
			let ObjItemMenu = $('.site-nav.desktop').find('li.site-nav__item');
			if ($('#menu_search').length === 1) {
				ObjItemMenu.push($('#menu_search')[0]);
			}
			
			ObjItemMenu.each(function (index, itm) {
				switch ($(itm).data('meganav-type')) {
					case "search":
						$self.createMainMenuItem($(itm), $self.toggleSearchMenu);
						break;
					case "parent":
						$self.createMainMenuItem($(itm), $self.toggleSubMenu);
						break;
					case "child":
						$self.createMainMenuItem($(itm), $self.toggleMenu);
						break;
					default:
						//NO ACTION
						break;
				}
			});
		};
		
		/**
		 * Gestione del container del Main Menu Mobile
		 * @param $_show
		 */
		this.toggleSubMenuMobile = function ($_id) {
		//console.log('---->>---> toggleSubMenuMobile',$_id);
			$self.switchMobileMenu($self.mobileMenuContainerActive,MenuDrawer.find('.menu-drawer[data-blockId=' + $_id + ']'));
		};
		
		/**
		 * Cambia il menu mobile visualizzato
		 *
		 * @param menuHide
		 * @param MenuShow
		 */
		this.switchMobileMenu = function (menuHide, MenuShow) {
		//	console.log('---> switchMobileMenu');
			if (menuHide != null) {
				menuHide.css({'opacity':0, "display":"none"});
				// $self.setData($siteHeaderBgScroll,'submenu-opened','');
			}
			
			if (MenuShow != null) {
				// $self.setData($siteHeaderBgScroll,'submenu-opened',MenuShow.getId());
				/**
				 * Chiudo il panel SEARCH se è aperto
				 */
				if (menuItem[$('#menu_search').data('meganav-id')].isOpened()) {
					menuItem[$('#menu_search').data('meganav-id')].closeSearchMenu();
				}
				MenuShow.css({'opacity':1, "display":"block"});
			}
			
			this.mobileMenuContainerActive = MenuShow;
		};
		
		this.menuMobileIsOpened = function () {
			return ($self.mobileMenuContainerActive != null);
		};
		
		this.toggleMenuMobile = function () {
		//	console.log('-----> toggleMenuMobile');
			var today = new Date();
			if (burgerMainMenu.attr('data-opened') == "true") {
				$("body").trigger("cos-toggleMenuMobile-before",false);
				this.toggleBgMenu(false);
				this.setData(MenuDrawer,'opened', false);
				this.setData(burgerMainMenu,'opened', false);
				this.switchMobileMenu(this.mobileMenuContainerActive,null);
				this.switchMobileMenu(MenuDrawer.find('.main-menu'),null);
			} else {
				$("body").trigger("cos-toggleMenuMobile-before",true);
				this.toggleBgMenu(true);
				this.setData(MenuDrawer,'opened', true);
				this.setData(burgerMainMenu,'opened', true);
				this.switchMobileMenu(this.mobileMenuContainerActive,MenuDrawer.find('.main-menu'));
			}
		};
		
		this.createMainMenuItemsMobile = function () {
			burgerMainMenu.on('click', function (e) {
				$self.toggleMenuMobile();
			});
			
			let ObjItemMenu = $('.site-nav.mobile').find('li');
			 ObjItemMenu.each(function (index, itm) {
			 	switch ($(itm).data('meganav-type')) {
			 		case "parent":
						$self.createMainMenuItemMobile($(itm), $self.toggleSubMenuMobile);
			 			break;
					case "back":
						$self.createMainMenuItemMobile($(itm), $self.toggleSubMenuMobile);
						break;
			 		default:
						//NO ACTION
			 			break;
			 	}
			 });
			
		};
		
		this.openSearchMenu = function () {
			if (!menuItem[$('#menu_search').data('meganav-id')].isOpened()) {
				menuItem[$('#menu_search').data('meganav-id')].openSearchMenu();
			}
		};
		
		this.init = function () {
			//Set header type
			$headerTransparent = ($('.header-wrapper--transparent').length === 1);
			//Set Menu Container
			//mainMenuContainer = $('.menu-center > ul');
			mainMenuContainer = $('#site-header-bg-menu-onhover,.menu-center > ul, .menu-container, .menu-container > .logo');
			
			burgerMainMenu = $('#burgerMainMenu');
			MenuDrawer = $('#MenuDrawer');
			
			
			//Set Search container to show after click on menu Search
			$menuSearchContainer = $('#menu-search-container');
			
			$siteHeaderBgScroll = $('#site-header-bg-scroll');
			
			$siteHeader = $(".site-header");
			$siteHeaderOriginal_Height = $siteHeader.css('height'); //"103px";// $siteHeader.css('height');
			//console.log('$siteHeaderOriginal_Height',$siteHeaderOriginal_Height);
			this.createMainMenuItems();
			this.createMainMenuItemsMobile();
			this.handleEvent();
		};
	}
	

/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  OSC Header background animation
==============================================================================*/

isHomePage = function () {
	return ($('.header-wrapper.indexpage').length !== 0);
};

(function () {
	
	/**
	 * Oggetto gestione Blocco Header
	 *
	 * * Gestione Main Menu
	 * * Gestione Scroll per home page
	 */
	function headerController() {
		// Self
		let $self = this;
		// Dom
		let $body = $("body");
		
		this.settings = {
			headerToggleLogo: false
		};
		
		let mc = null;
		
		let linkClass = "textBlack";
		
		this.getScrollTop = function () {
			return $(window).scrollTop();
		};
		
		
		this.setOnlyBackGroundSize = function (e) {
			//	console.log('setOnlyBackGroundSize');
			let st = this.getScrollTop();
			
			$("#site-header-bg-scroll").height(st);
		};
		
		/**
		 * Gestione del blocco HEADER allo scroll per la home page
		 * @param e
		 */
		this.setBackGroundSize = function (e) {
			let st = this.getScrollTop();
			
			$("#site-header-bg-scroll").height(st);
			if (st > 0) {
				$('.burger-icon', '#burgerMainMenu').css('background-color', '#000000');
				//$('#menuTopCart').find('.st0').css('fill', '#000000');
				$('#menuTopCart').addClass('black');
				$('.a', '#menuTopAccount').css('stroke', '#000000');
				$('#headerLogoImg').css('display', 'none');
				$('#headerLogoImgBlack').css('display', 'block');
				
				$('.a', '#menuTopSearch').css('stroke', '#000000');
				$('#menuTopSearch').css('fill', '#000000');
				// $('#headerLogoImg').addClass('hidden');
				// $('#headerLogoImgBlack').removeClass('hidden');
				$('.site-header').addClass(linkClass);
				
				$('#menuTopCartTotElement').css('color', "#000000");
				
			} else {
				
				if (!mc.isOpened() && !mc.isOpenedSearch()) {
					$('.burger-icon', '#burgerMainMenu').css('background-color', '#FFFFFF');
					//	$('#menuTopCart').find('.st0').css('fill', '#FFFFFF');
					$('#menuTopCart').removeClass('black');
					
					$('.a', '#menuTopAccount').css('stroke', '#FFFFFF');
					$('#headerLogoImg').css('display', 'block');
					$('#headerLogoImgBlack').css('display', 'none');
					// $('#headerLogoImg').removeClass('hidden');
					// $('#headerLogoImgBlack').addClass('hidden');
					$('.a', '#menuTopSearch').css('stroke', '#FFFFFF');
					$('#menuTopSearch').css('fill', '#FFFFFF');
					
					$('.site-header').removeClass(linkClass);
					$('#menuTopCartTotElement').css('color', "#FFFFFF");
				}
			}
		};
		
		/**
		 * Gestione eventi
		 */
		this.handleEvent = function () {
			/**
			 * Manage Header Scroll
			 */
			if (this.settings.headerToggleLogo) {
				$(window).scroll(function (e) {
					$self.setBackGroundSize(e);
				});
			} else {
				/*	$(window).scroll(function (e) {
						$self.setOnlyBackGroundSize(e);
					});*/
			}
			
			theme.cache.$window.on('resize', theme.debounce($self.setElementViews, 150));
			
			$("body").on("cos-toggleSidebar-open-before", function (e) {
				//$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
				if ($(window).width() <= 990) {
					$('#site-header-bg-menu-onhover').css({'backgroundColor': '#FFFFFF'});
					$('#site-header-bg-menu-onhover').css({'opacity': 1});
				}
			});
			
			$("body").on("cos-toggleSidebar-clore-after", function (e) {
				//$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
				if ($(window).width() <= 990) {
					$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
					$('#site-header-bg-menu-onhover').css({'opacity': 0});
				}
			});
			
			$("body").on("cos-toggleSearchMenu-before", function (e, $_id, $_show) {
				console.log('cos-toggleSearchMenu-before',$_show);
				if ($_show) {
					$('#site-header-bg-menu-onhover').css({'backgroundColor': 'transparent'});
					if (isHomePage()) {
						$('#menuTopCartTotElement').css('color', '#000000');
					}
				} else {
					//$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
					let st = $("#site-header-bg-scroll").height();
					if (st <= 0) {
						if (isHomePage()) {
							$('#site-header-bg-menu-onhover').css({'backgroundColor': '#FFFFFF'});
						}
					}
				}
				
				
				
			});
			
			let bgColorBgMenu = $('#site-header-bg-menu-onhover');
			let siteHeaderBgColor = $('.site-header').css('backgroundColor');
			$("body").on("cos-toggleBgMenu-before", function (e, $_show) {
				if ($_show) {
					if (resolution_IsMobile() || resolution_IsIbrid()) {
						if (mc.isOpenedSearch()) {
							$('#site-header-bg-menu-onhover').css({'backgroundColor': 'transparent'});
						} else {
							$('#site-header-bg-menu-onhover').css({'backgroundColor': '#FFFFFF'});
						}
					} else {
						$('#site-header-bg-menu-onhover').css({'backgroundColor': '#FFFFFF'});
						$('.site-header').css({'backgroundColor': '#FFFFFF'});
					}
					
					$('#site-header-bg-menu-onhover').css({'opacity': 1});
					
				} else {
					
					//$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
					if ($('.col-filter.open').length <= 0) {
						$('#site-header-bg-menu-onhover').css({'backgroundColor': 'transparent'});
						$('#site-header-bg-menu-onhover').css({'opacity': 0});
						if (resolution_IsMobile() || resolution_IsIbrid()) {
						
						} else {
							$('.site-header').css({'backgroundColor': siteHeaderBgColor});
						}
					}
				}
			});
			
			$("body").on("cos-toggleBgMenu-after", function (e, $_id) {
				if (mc.isHeaderTransparent()) {
					if (mc.isOpened() === true || mc.isOpenedSearch() === true) {
						$('.burger-icon', '#burgerMainMenu').css('background-color', '#000000');
						//$('#menuTopCart').find('.st0').css('fill', '#000000');
						$('#menuTopCart').addClass('black');
						$('.a', '#menuTopAccount').css('stroke', '#000000');
						
						$('.a', '#menuTopSearch').css('stroke', '#000000');
						$('#menuTopSearch').css('fill', '#000000');
					} else {
						if ($self.getScrollTop() <= 0) {
							$('.burger-icon', '#burgerMainMenu').css('background-color', '#FFFFFF');
							//	$('#menuTopCart').find('.st0').css('fill', '#FFFFFF');
							$('#menuTopCart').removeClass('black');
							
							$('.a', '#menuTopAccount').css('stroke', '#FFFFFF');
							$('.a', '#menuTopSearch').css('stroke', '#FFFFFF');
							$('#menuTopSearch').css('fill', '#FFFFFF');
						}
					}
				}
			});
			
			$("body").on("cos-toggleSearchMenu-hide-after", function (e, $_id) {
				let st = $self.getScrollTop();
				//$("#site-header-bg-scroll").height(st);
				if (st > 0) {
					// $('.burger-icon', '#burgerMainMenu').css('background-color', '#000000');
					// $('#menuTopCart').css('fill', '#000000');
					// $('#headerLogoImg').css('display', 'none');
					// $('#headerLogoImgBlack').css('display', 'block');
					// // $('#headerLogoImg').addClass('hidden');
					// // $('#headerLogoImgBlack').removeClass('hidden');
					$('.site-header').addClass(linkClass);
				} else {
					if (!mc.isOpened() && !mc.isOpenedSearch()) {
						// $('.burger-icon', '#burgerMainMenu').css('background-color', '#FFFFFF');
						// $('#menuTopCart').css('fill', '#FFFFFF');
						// $('#headerLogoImg').css('display', 'block');
						// $('#headerLogoImgBlack').css('display', 'none');
						// // $('#headerLogoImg').removeClass('hidden');
						// // $('#headerLogoImgBlack').addClass('hidden');
						//		console.log('menu opened')
						$('.site-header').removeClass(linkClass);
						if (isHomePage()) {
							$('#menuTopCartTotElement').css('color', '#FFFFFF');
						}
					} else {
						//	console.log('no menu opened')
					}
				}
			});
			
			$("body").on('cos-toggleMenuMobile-before', function (e, $_show) {
				console.log('cos-toggleMenuMobile-before',$_show, 'opened seafh',mc.isOpenedSearch());
				if ($_show) {
					if (isHomePage()) {
						$('#menuTopCartTotElement').css('color', '#000000');
					}
					
				} else {
					let st = $("#site-header-bg-scroll").height();
					if (st <= 0) {
						if (isHomePage() && !mc.isOpenedSearch()) {
							$('#menuTopCartTotElement').css('color', '#FFFFFF');
						}
						
					}
				}
			});
		};
		
		/**
		 * Gestione degli elementi al resize
		 */
		this.setElementViews = function (e) {
		
		};
		
		/**
		 * Imposta il colore dell'header in  base ai settings delle sezioni
		 * Es. collection template
		 */
		this.getGetColorHeader = function () {
			let $CollectionSection = $('#CollectionSection');
			if ($CollectionSection.length === 1) {
				/**
				 * Sono in una collection, prelevo il colore dai settings
				 */
				if ($CollectionSection.data('style-bg-color') !== 'undefined') {
					return $CollectionSection.data('style-bg-color');
				}
			}
			return "#FFFFFF";
		};
		
		/**
		 * Apre la search
		 *
		 */
		this.openSearchMenu = function () {
			mc.openSearchMenu();
		};
		
		this.init = function (options) {
			this.settings = $.extend(this.settings, options);
			let bgc = $self.getGetColorHeader();
			// $('.site-header').css('background-color', bgc);
			// $('#PageContainer').css('backgroundColor', bgc);
			// $('.site-header').css('backgroundColor', bgc);
			// $('.site-nav__dropdown').css('backgroundColor', bgc);
			// $('.site-nav--has-dropdown').css(':hover', bgc);
			// .header-wrapper .site-nav__link:hover .burger-icon
			// $('.site-header').css('background-color', $self.getGetColorHeader());
			$('#site-header-bg-menu-onhover').css({'backgroundColor': $self.getGetColorHeader()});
			this.handleEvent();
			
			/**
			 * Set Main Menu
			 * @type {MainMenuController}
			 */
			mc = new MainMenuController();
			mc.init();
		};
	}
	
	// Export variable
	let hc = new headerController();
	window.cosHeaderController = {
		init: hc.init.bind(hc),
		openSearchMenu: hc.openSearchMenu.bind(hc)
	};
	
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  OSC Console
  
  manage console messagge with verbose level
==============================================================================*/
(function () {
    function consoleCos() {

        this.settings = {
            inDebug: false, //Debug active
            verbose: 1 //Verbose level
        };
    
    
        this.init = function (options) {
            // Override defaults with arguments
            this.settings = $.extend(this.settings, options);
        };
    
        /**
         * Set verbose level
         * 1 = Error
         * 2 = Error / Warning
         * 3 = Error / Warning / Log
         * @param level
         */
        this.setVerbose = function (level) {
            if (level == 1 || level == 2 || level == 3)
            {
                this.settings.verbose = level
            }
        };
      
        this.log = function(...args) {
            if (this.settings.verbose > 2) {
                console.log(args);
            }
        };
    
        this.warn = function(...args) {
            if (this.settings.verbose > 1) {
                console.warn(args);
            }
        };
    
        this.error = function(...args) {
            if (this.settings.verbose > 0) {
                console.error(args);
            }
        };
    }

    // Export variable
    let cc = new consoleCos();
    window.consoleCos = {
        init: cc.init.bind(cc),
        setVerbose: cc.setVerbose(cc),
        log: cc.log.bind(cc),
        warn: cc.warn.bind(cc),
        error: cc.error.bind(cc)
    }
    
})();
/* --/// BEGIN OTHER FILE //-- */
function generateRandomString(length) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

/** ANIMATIONS  */
function slideMenuPanel($object, from, to, opacityFrom, opacityTo, time) {
    return new Promise(function (resolve) {
        TweenMax.fromTo($object, time,
            {"y": from, "opacity": opacityFrom},
            {"y": to, "opacity": opacityTo, delay: 0, ease: Power2.easeInOut, onComplete: resolve}
        );
    });
}

function scrollToTop() {
    $(window).scrollTop(0);
}

function scrollToY(y) {
    $(window).scrollTop(y);
}


/**
 * Verify $key present in $obj JSON Object
 * @param $key string to search
 * @param $obj JSON Obeject
 */
function keyExistsInObject($key, $obj) {
    if ($obj === undefined) {
        return false;
    }
    
    if ($key.indexOf(".") > 0) {
        $keys = $key.split(".");
        let $obj_test = $obj;
        let KeyFound = false;
        $($keys).each(function (_index, _key) {
            if (!keyExistsInObject(_key, $obj_test)) {
                KeyFound = false;
                return false;
            } else {
                KeyFound = true;
            }
            $obj_test = $obj_test[_key];
        });
        return KeyFound;
    } else {
        if (($key in $obj)) {
            return ($obj[$key] !== undefined);
        }
        return false;
    }
}

/**
 * Get value in $obj JSON Object
 * @param $key string to search
 * @param $obj JSON Obeject
 */
function getValueFromObject($key, $obj) {
    if ($obj === undefined) {
        return false;
    }
    if ($key.indexOf(".") > 0) {
        $keys = $key.split(".");
        let $obj_test = $obj;
        let KeyFound = false;
        $($keys).each(function (_index, _key) {
            if (!keyExistsInObject(_key, $obj_test)) {
                KeyFound = false;
                return false;
            } else {
                KeyFound = true;
            }
            $obj_test = $obj_test[_key];
        });
        if (KeyFound) {
            return $obj_test;
        } else {
                return undefined;
        }
    } else {
        if (($key in $obj)) {
            return $obj[$key];
        }
        return undefined;
    }
}


// result container
var res = {};

// input data
var inp = [
    'data.location.degree.text=sometexthere',
    'data.otherLocation.degree.otherText=foo',
    'data.location.degree.otherText=bar',
    'we.can.do.undefined.values='
];


/**
 * Crea un oggetto da una stringa
 *
 * Es.
 *  * data.location.degree.text=defaultValue -> ["data", "location", "degree", "text=defaultValue"]
 *  * data.location.degree.text -> ["data", "location", "degree", "text"]
 *
 * @param resultReference Oggetto risultante
 * @param path data.location.degree.text=sometexthere
 * @param splitString Stringa per cui spltitare la path Es.  (.)
 */
var pathToObject = function(resultReference, path, splitString, value)
{
    var splitPathParts = path.split(splitString);
    
    // Es. ["text=sometexthere"]
    if (splitPathParts.length === 1){
        // split "text=defaultValue" in ["text", "defaultValue"]
        var keyAndValue = splitPathParts[0].split('=');
        // resultReference[keyAndValue[0]] = keyAndValue[1];
        let defaultValue = null;
        if (keyAndValue.length === 2) {
            defaultValue = keyAndValue[1];
        }
        if (value === undefined) {
            resultReference[keyAndValue[0]] = defaultValue;
        } else {
            resultReference[keyAndValue[0]] = value;
        }

        return resultReference;
    }
    
    /**
     * Il primo elemento dell'array è la chiave corrente
     *
     * Es. per ["data", "location", "degree", "text=sometexthere"],
     * currentKey è "data";
     *
     * @type {T}
     */
    
    var currentKey = splitPathParts.shift();
    
    /**
     * se il nostro oggetto non contiene ancora la CHIAVE corrente, la impostiamo su un oggetto vuoto
     */
    resultReference[currentKey] || (resultReference[currentKey] = {});
    
    
    /**
     * Richiamiamo ricorsivamente la funzione
     * L'oggetto corrente ed il resto della path
     * Es. { data : {} } and 'location.degree.text=sometexthere'
     */
    resultReference[currentKey] = pathToObject(resultReference[currentKey], splitPathParts.join(splitString),splitString,value);
    return resultReference;
};

/**
 * Show errors on te template  only to merchant in the editor.
 * @param $error
 */
addErrorOnBody = function ($error) {
    if (shopifyDesignMode) {
        $("body").prepend('<div class="errors">' + $error + '</div>');
    }
};

/**
 * Verify user logged in admin area
 */
shopifyDesignMode = function () {
   return Shopify.designMode;
};

/**
 * Check resolution is MOBILE
 * @returns {boolean}
 */
resolution_IsMobile = function () {
    return theme.variables.bpSmall;
};

/**
 * Check resolution is IBRID
 * @returns {boolean}
 */
resolution_IsIbrid = function () {
    return theme.variables.bpIbrid;
};

/**
 * Check resolution is DESKTOP
 * @returns {boolean}
 */
resolution_IsDesktop = function () {
    return theme.variables.bpDesktop;
};

/**
 * Check resolution is LARGE
 * @returns {boolean}
 */
resolution_IsLarge = function () {
    return theme.variables.bpLarge;
};
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Manage Cookie for app

==============================================================================*/
(function () {
	
	function manageCosCookie () {
		let $body = $('body');
		// Self
		let $self = this;
		
		/**
		 * Lista dei settings per gestire i cookie
 		 */
		let settings =  {
			prefix: 'cos_', //prefix to save into browser
			separator: '.', //Key separator for object cookie
			keys: null //List of keys manage
		};
		
		/**
		 * Array dei cookie da gestire nell'app
		 * ogni settings sarà un chiave dell'array cookie presente nell'oggetto keys
		 */
		this.cookie = null;
		
		this.createCookieInBrowserIfNotExists = function ($_key, $_expires) {
			let $prefixKey = this.getSettings("prefix")+$_key;
			if (typeof $.cookie($prefixKey) === 'undefined') {
				this.saveCookie($prefixKey, getValueFromObject($_key, this.cookie), $_expires);
			}
		};
		
		this.saveCookie = function ($_key, $_value, $_expires) {
			let expires = 7;
			if (!isNaN(parseInt($_expires))) {
				expires = $_expires;
			}
			
			//console.log('SAVE COOKIE REAL',$_key,$_value);
			
			$.cookie($_key, $_value, { expires: expires, path: '/'  });
		};
		
		/**
		 * Preleva i cookie dal browser
		 *
		 * cos__cookietest.value_name_separated_from_underscore=null
		 * cos__cookietest.value_name_separated_from_underscore.velue2_test=null
		 */
		this.setCookieFromBrowser = function () {
			if (this.cookie == null) {
				if (this.cookieConfigOk()) {
					this.cookie=[];
					for (let i = 0; i < this.getSettings("keys").length; i++) {
						let $key = settings.keys[i];
						let $prefixKey = this.getSettings("prefix")+$key;
						let $prefixKeyNoValue = $prefixKey.split("=");
						
						this.cookie = pathToObject(this.cookie, $key, this.getSettings('separator'), $.cookie($prefixKeyNoValue[0]));
						
						let $keyNovalue=  $key.split("=");
						
						this.createCookieInBrowserIfNotExists($keyNovalue[0]);
					}
				}
			}
		};
		
		/**
		 * Verifica se sono stati impostati i settings dei cookie
		 * @returns {boolean}
		 */
		this.cookieConfigOk = function () {
			return (keyExistsInObject ('keys',settings));
		};
		
		/**
		 * Forza i settings base necessari,
		 * se sono stati sovrascritti erroneamente in fase di inizializzazion del componente
		 */
		this.setBasicSettingsIfNotExists = function () {
			if (keyExistsInObject('prefix', settings)) {
				if (settings.prefix === '') {
					settings.prefix = 'cos_';
				}
			} else {
				settings.prefix = 'cos_';
			}
			
			if (keyExistsInObject('separator', settings)) {
				if (settings.separator === '') {
					settings.separator = '.';
				}
			} else {
				settings.separator = '.';
			}
			
			if (!keyExistsInObject('keys', settings)) {
				settings.keys = null;
			}
		};
		
		/**
		 * Get settings value
		 * @param $key
		 * @returns {null|*}
		 */
		this.getSettings = function ($key) {
				if ($key != null) {
					if (($key in settings)) {
						if (settings[$key]) {
							return settings[$key];
						}
					}
				}
				return null;
		};
		
		

		this.getValue = function (path) {
			return getValueFromObject(path, this.cookie);
		};
		
		this.setValue = function ($_key, $_value,$_expires) {
			//console.log('cosCookie -> setValue',$_key,$_value);
			if (keyExistsInObject($_key,this.cookie)) {
				let $prefixKey = this.getSettings("prefix")+$_key;
				this.saveCookie($prefixKey, $_value, $_expires);
			}
			// return getValueFromObject(path, this.cookie);
			
		};
		
		
		/**
		 * Inizializzazione oggetto
		 * @param options
		 */
		this.init = function (options) {
			// Override defaults with arguments
			$.extend(settings, options);
			
			this.setBasicSettingsIfNotExists();
			this.setCookieFromBrowser();
		};
	}

	// Export variable
	let cosCookie = new manageCosCookie();
	window.cosCookie = {
		init: cosCookie.init.bind(cosCookie),
		getValue: cosCookie.getValue.bind(cosCookie),
		setValue: cosCookie.setValue.bind(cosCookie)
	};
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Gestione PopUp newsletter
  
==============================================================================*/
(function () {
	
	function newsletterPopUp() {
		
		let cookieKeys = {
				cookieKeyPoupShow :'newsletter.popup.show'
		};
		
		this.setCookieShow = function () {
			window.cosCookie.getValue('newsletter.popup.show')
		};
		
		this.showPopUp = function () {
			if (window.cosCookie !== undefined) {
				if (typeof window.cosCookie.getValue(cookieKeys.cookieKeyPoupShow) != 'undefined') {
					if (window.cosCookie.getValue(cookieKeys.cookieKeyPoupShow) === "true") {
						
						if ($('#cosPopupNewsletter_container')[0]) {
							$.magnificPopup.open({
								mainClass: "bgDark",
								items: {
									src: '#cosPopupNewsletter_container'
								},
								type: 'inline',
								callbacks: {
									open: function() {
										var magnificPopup = $.magnificPopup.instance;
										$('body,html').css('overflow', 'hidden');
									},
									close: function () {
										// Will fire when popup is closed
										$('body,html').css('overflow', '');
										window.cosCookie.setValue(cookieKeys.cookieKeyPoupShow, "false");
									}
								}
							});
						}
					}
				}
			}
		};
		
		/**
		 * Inizializzazione oggetto
		 * @param options
		 */
		this.init = function () {
			this.showPopUp();
		};
	}
	
	// Export variable
	let cc = new newsletterPopUp();
	window.newsletterPopUp = {
		init: cc.init.bind(cc)
	}
	
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Collection Carousel
  
==============================================================================*/
(function () {
	function collection_carousel(dom) {
		let $id = dom.data("section-id");
		let $carousel = null;
		
		let $items = null;
		
		this.settings = {
			loop: false,
			margin: 0,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout:2000,
			autoplayHoverPause: true,
			// center:true,
			mouseDrag: true,
			touchDrag: true,
			// stagePadding:50,
			responsive: {
				0: {
					items: 1,
					center: true
					// stagePadding:50
				},
				590: {
					items: 5
				}
			}
		};
		
		this.getId = function () {
			return $id;
		};
		
		this.getCarousel = function () {
			if ($carousel == null) {
				$carousel = $('.owl-carousel', "#cosCollectionCarousel_" + $id);
			}
			return $carousel;
		};
		
		this.destroy = function () {
			if ($carousel != null) {
				this.getCarousel().owlCarousel('destroy');
				$carousel = null;
				$items = null;
			}
		};
		
		this.create = function (options) {
			this.settings = $.extend(this.settings, options);
			this.destroy();
			
			this.getCarousel().owlCarousel(this.settings);
			$items = this.getCarousel().find('.item');
			
			this.addHandler();
		};
		
		this.addHandler = function () {
			//manege hover event
			this.setItemTitleSameHeight($items);
			
			$($items).hover(
				function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 1);
					}
				}, function () {
					if (!resolution_IsMobile()) {
						$(this).find('.show-on-hover-desktop').css('opacity', 0);
					}
				}
			);
		};
		
		this.setItemTitleSameHeight = function ($items) {
			var titleHeight = 0;
			$(".title.show-on-hover-desktop", $items).each(function (title_index, title_itm) {
				if (titleHeight < $(title_itm).outerHeight()) {
					titleHeight = $(title_itm).outerHeight();
				}
			});
			if (titleHeight > 0) {
				$(".title.show-on-hover-desktop", $items).css("height", titleHeight);
			//	console.log('items',$($items),	$($items).css("margin-top"));
				$($items).css("margin-top", "-"+titleHeight+"px");
			}
		};
		
	}
	
	function collectionCarouselController() {
		let $carouselItems = [];
		this.settings = {
			selector: '.cosCollectionCarousel'
		};
		
		this.getItems = function () {
			return $carouselItems;
		};
		
		
		this.init = function (options) {
			// Override defaults with arguments
			this.settings = $.extend(this.settings, options);
			
			
			$(this.settings.selector).each(function (index, itm) {
				const c = new collection_carousel($(itm));
				
				let vi_m = 1.8;
				let vi_d = 3;
				
				if ($(itm).data("visible-items-mobile") !== undefined) {
					vi_m = $(itm).data("visible-items-mobile");
				}
				if ($(itm).data("visible-items-desktop") !== undefined) {
					vi_d = $(itm).data("visible-items-desktop");
				}
				
				let options = {
					loop:true,
					responsive: {
						0: {
							items: vi_m,
							center: true,
							autoWidth: true,
							startPosition: 2
						},
						590: {
							items: vi_d,
							center: false/*,
							stagePadding:150*/
						}
					}
				};
				c.create(options);
				$carouselItems[c.getId()] = c;
			});
			
		};
		
		
	}
	
	
	// Export variable
	let carouselController = new collectionCarouselController();
	window.carouselController = {
		init: carouselController.init.bind(carouselController),
		getCarousel: carouselController.getItems.bind(carouselController)
	};
})();
/* --/// BEGIN OTHER FILE //-- */
/*============================================================================
  Accordion
  
==============================================================================*/
(function () {
	function accordion(dom) {
		let $parent;
		let $self = this;
		let $dom = dom;
		let $id = $dom.data("section-id");
		
		let $panel = null;
		
		this.settings = {
			class: {
				active: "active"
			}
		};
		
		this.getPanel = function () {
			return $panel;
		};
		
		this.getDom = function () {
			return $dom;
		};
		
		this.getId = function () {
			return $id;
		};
		
		this.addHandler= function () {
			$dom.on("click", function(e) {
					$self.toggle();
			});
		};
		
		this.toggle = function () {
			if ($panel.css("maxHeight") !== '0px') {
				$self.close();
			} else {
				$self.open();
			}
		};
		
		this.close = function () {
			console.log('accordion close',$dom);
			$dom.removeClass($self.settings.class.active);
			$parent.trigger("accordion-close-before",[this]);
			$panel.css("maxHeight", "0px");
			$parent.trigger("accordion-close-after",[this]);
		};
		
		this.open = function () {
			console.log('accordion open',$dom);
			$dom.addClass($self.settings.class.active);
			$parent.trigger("accordion-open-before",[this]);
			$panel.css("maxHeight", $panel.prop('scrollHeight') + "px");
			$parent.trigger("accordion-open-after",[this]);
		};
		
		this.init = function ($_parent,options) {
			$parent = $_parent;
			// Override defaults with arguments
			this.settings = $.extend(this.settings, options);
			$panel = $dom.next();
			this.addHandler();
		};
	}
	
	
	function _accordionController() {
		let $accordionItems = [];
		let $currentItem = null;
		
		$self = $(this);
		this.add = function (dom) {
			let acc = new accordion(dom);
			acc.init($self);
			$accordionItems[acc.getId()] = acc;
		};
		
		$self.on('accordion-open-before' ,function (evt,itm) {
			if($currentItem && $currentItem!==itm) {
				$currentItem.close();
			}
		});
		
		$self.on('accordion-open-after' , function (evt,itm) {
			$currentItem=itm;
		});
	}

	// Export variable
	let accordionController = new _accordionController();
	window.accordionController = {
		add: accordionController.add.bind(accordionController)
	};
})();
/* --/// BEGIN OTHER FILE //-- */
$(function () {
	/**
	 * Create Console Object for Verbose Log
	 *
	 * set inDebug = false if sto console log
	 *
	 * set Verbose Level, read comment into object
	 */
	consoleCos.init(
		{
			inDebug:true,
			verbose:3
		}
	);
	
	/**
	 * Init header object
	 *
	 * window.headerToggleLogo set in "SECTION" header.liquid
	 */
	cosHeaderController.init({headerToggleLogo: window.headerToggleLogo});
	
	/**
	 * Create Cookie object
	 *
	 * Pass list of Settings.
	 *
	 * Mandatory "keys" without prefix (Ex. cos_). The prefix string added automatically by the component
	 *
	 * Es. {'keys':['geoip.base_url=http://www.website.it','geoip.state=IT,EN','newsletter.popup.show=null']}
	 */
	if (typeof cosCookie !== 'undefined') {
		cosCookie.init(
			{
				'prefix': 'cos_',
				'keys': ['newsletter.popup.show=true', 'newsletter.popup.title="SI"', 'newsletter.popup.description="DESC"', "collection.filter.opened=false"]
			}
		);
	}
	
	/**
	 * Gestione newlestter popup
	 */
	if (typeof newsletterPopUp !== 'undefined') {
		newsletterPopUp.init();
	}
	
	/**
	 * Initialize BackInStock popup
	 */
	if (typeof backInStockPopUp !== 'undefined') {
		backInStockPopUp.init();
	}
	
	/**
	 * Initialize accordionController
	 */
	if (typeof window.accordionController !== "undefined") {
		$('.accordion','#product_details_accordion').each(function (index, item) {
				window.accordionController.add($(item));
		});
	}
	
	/**
	 * Create Carousel Controller
	 */
	carouselController.init();
	
	/**
	 * Veririca Script per la pagina Dettaglioprodotto
	 */
	if (typeof window.completeYourLookCarouselController !== "undefined") {
		window.completeYourLookCarouselController.init();
		
		$('.cosProductSelectVariant').each(function (index, item) {
			window.cosProductSelectVariantCollection.add($(item));
		});
	}
	
	/**
	 * Veririca Script per la pagina cosProductTemplate
	 */
	if (typeof window.cosProductTemplate !== "undefined") {
		window.cosProductTemplate.init();
	}
	
	
	/**
	 * Verifica script recommendation product per la pagina Dettaglioprodotto
	 * Called on theme.js by theme.CosProductRecommendations
	 */
	// if (typeof window.productRecommendationsCarouselController !== "undefined") {
	// 	window.productRecommendationsCarouselController.init($('#cosProductRecommendationsWrapper'));
	// }
	
	
	/**
	 * Verifica script recommendation product per la pagina Dettaglioprodotto
	 *
	 */
	if (typeof window.cosCart !== "undefined") {
		window.cosCart.init($('#cosCart'));
	}
	
	

	
	/**
	 * Manage Check Password and Confirm Password in Create new account Form
	 */
	$('#create_customer').validate({
		rules: {
			"customer[email]": {
				required: true,
				email: true
			},
			"customer[confirmemail]": {
				required: true,
				email: true,
				equalTo: '#Email'
			},
			"customer[password]": {
				required: true
			},
			"customer[password_confirmation]": {
				required: true,
				equalTo: '#CreatePassword'
			},
			
		},
		errorPlacement: function (error, element) {
			if (element.attr('type') == 'checkbox') {
				error.insertAfter(element.parent());
			} else {
				error.insertAfter(element);
			}
			// console.log('errorPlacement');
			
		},
		submitHandler: function (form) {
			//   signUpToMailchimp(form);
			//    alert('Submit form');
			//    loaderRemove();
			// Settiamo il submit handler per la form
			
			form.submit();
		},
		invalidHandler: function (event, validator) {
			// loaderRemove();
			// console.log('invalidHandler');
		},
		success: function (event, validator) {
			// console.log('validate success');
			//   let toH=openCloseFormCalculateHeight();
			//   animateForm(toH);
		}
	});
	
	
	// });
	
	/**
	 * Delete item from CART PAGE
	 */
	$('.btndelete', '#cos-cart').each(function (index, btn) {
		if ($(btn).data('linkto') !== undefined) {
			if ($(btn).data('linkto') !== "") {
				$(btn).on('click', function (e) {
					$(window).attr('location', currentShopUrl + $(btn).data('linkto'));
				});
			}
		}
	});
	
	
	/**
	 * Footer  newsletter form
	 */
	$('#cosFooterNewsletter').validate({
		rules: {
			"email": {
				required:true,
				mail: true
			},
			"acceptrivacy": {
				required: true
			}
		},
		errorPlacement: function (error, element) {
			if (element.attr('type') == 'checkbox') {
				error.appendTo($('#cosFooterNewsletter_privacy_err_newsletter'));
				$('#cosFooterNewsletter_privacy_err_newsletter').removeClass('hide').css({"width":"100%"});
			} else {
				error.insertAfter(element);
			}
			
		},
		submitHandler: function (form) {
			form.submit();
		},
		invalidHandler: function (event, validator) {
			// console.log('non valido');
		},
		success: function (event, validator) {
			// console.log('success');
		}
	});
	
	/**
	 * Popup  newsletter form
	 */
	$('#cosPopupNewsletter').validate({
		rules: {
			"email": {
				required:true,
				mail: true
			},
			"acceptrivacy": {
				required: true
			}
		},
		errorPlacement: function (error, element) {
			if (element.attr('type') == 'checkbox') {
				error.appendTo($('#cosPopupNewsletter_privacy_err_newsletter'));
				$('#cosPopupNewsletter_privacy_err_newsletter').removeClass('hide').css({"width":"100%"});
			} else {
				error.insertAfter(element);
			}
			
		},
		submitHandler: function (form) {
			form.submit();
		},
		invalidHandler: function (event, validator) {
			// console.log('non valido');
		},
		success: function (event, validator) {
			// console.log('success');
		}
	});
	
	/**
	 * Form REGISTER new user
	 */
	$('#cosCrateCustomer').validate({
		rules: {
			"email": {
				required:true,
				mail: true
			},
			"acceptrivacy": {
				required: true
			}
		},
		errorPlacement: function (error, element) {
			if (element.attr('type') == 'checkbox') {
				error.appendTo($('#cosCrateCustomer_privacy_err'));
				$('#cosCrateCustomer_privacy_err').removeClass('hide').css({"width":"100%"});
			} else {
				error.insertAfter(element);
			}
		},
		submitHandler: function (form) {
			form.submit();
		},
		invalidHandler: function (event, validator) {
			// console.log('non valido');
		},
		success: function (event, validator) {
			// console.log('success');
		}
	});
	
	
	/**
	 * Form Page CONTACTS
	 */
	$('#cosCmsContacts').validate({
		rules: {
			"email": {
				required:true,
				mail: true
			},
			"acceptrivacy": {
				required: true
			}
		},
		errorPlacement: function (error, element) {
			if (element.attr('type') === 'checkbox') {
				error.appendTo($('#cosCmsContacts_privacy_err'));
				$('#cosCmsContacts_privacy_err').removeClass('hide').css({"width":"100%"});
			} else {
				error.insertAfter(element);
			}
		},
		submitHandler: function (form) {
			form.submit();
		},
		invalidHandler: function (event, validator) {
			// console.log('non valido');
		},
		success: function (event, validator) {
			// console.log('success');
		}
	});
	
	
	/**
	 * PopUp Close -
	 */
	$('.btnExtraPopUpClose').on ('click', function () {
			$.magnificPopup.close();
		}
	);
	
	/**
	 * Personalizzazione bottone PickUpInStock se sono nel dettaglio prodotto
	 */
	if ($("body").hasClass('template-product')) {
		/**
			* FIX Sticky se ricarico la pagina con il valore scroll top > 0;
			*/
		setTimeout(function () {
			$("html, body").animate({scrollTop: 0}, "fast");
		}, 500);
	}
	
		/**
	 * Personalizzazione bottone PickUpInStock se sono nel carrello
	 */
	if ($("body").hasClass('template-cart')) {
		//console.log('SONO NEL CARRELLO')
		//console.log('TROVO IL BOTTONE PICKUP', $('.js-toggle-pickup').length);
		if ($('.js-toggle-pickup').length == 1) {
			//console.log('TROVATO AGGIUNGO LA MIA CLASSE');
			$('.js-toggle-pickup').addClass('btnStockePickUp');
		}
	}
	
	if ($("body").hasClass('template-customers-login')) {
	
	}
	
	
	/**
	 * Apre la ricerca dal footer
	 */
	$('#openSearchFromFooter').on('click', function (evt) {
		evt.preventDefault();
		console.log('OPEN FROM FOOTER',window.cosHeaderController);

		window.cosHeaderController.openSearchMenu();
		$("html, body").animate({scrollTop: 0}, "fast");
	});
	
	/**
	 * Chiude l'immagine ovrlay e visualizza il video
	 */
	$('.btnCosFeaturedVideo').on('click',function (){
		let $parent=$(this).parents('.cosFeaturedVideo');
		$parent.find('.image-overaly').css({'display':'none'});
		$parent.find('.video-content').css({'opacity':1});
		$parent.find('iframe').contents().find('#player').click();
		
	});
});
/* Updated on: 30th Sep, 2:15:32 PM */